import React from 'react';
import Slider from 'react-slick';
import RealEstateBannerImg from '../../../assets/images/real-estate-management-banner.jpg';


const RealEstateBanner = () => {
    const bannerSettings = {
        dots: true,
        infinite: true,
        speed: 200,
        autoplay: true,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        fade: true,
        arrows: false,
        slidesToScroll: 1
    };

    return (
        <section className="banner-one">
            <div className="container-fluid p-0">
                <Slider className="banner-one-slider" {...bannerSettings}>
                    <div className="banner-one-slider-item">
                        <div className="banner-one-slider-item-image zoom-in">
                            <img
                                src={RealEstateBannerImg}
                                alt="Real Estate Banner"
                                className="img-fluid w-100"
                                style={{ maxHeight: '500px', objectFit: 'cover' }}
                            />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-7 col-lg-8 col-md-10">
                                    <div className="banner-one-info" id='banner-one-info'>
                                        <div className="banner-title fade-left hero">
                                            <h1>Real Estate Management</h1>
                                        </div>
                                        <div className="section-details fade-left head">
                                            <h3 className='text-white'>
                                                Seamless property solutions. For NRIs anywhere.
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        </section>
    );
};

export default RealEstateBanner;
